import { useSidebar } from '../../contexts/SidebarContext';
import { AccountSheet } from './sheet/AccountSheet';
import { OpportunitySheet } from './sheet/OpportunitySheet';
import { LeadSheet } from './sheet/LeadSheet';
import { SubscriberDetailSidebar } from './SubscriberDetailSidebar';
import { ContactSheet } from './sheet/ContactSheet';
import { MeetingReportSidebar } from './MeetingReportSidebar';
import { AppointmentDetailSidebar } from '../appointments/AppointmentDetailSidebar';

export function GlobalSidebars() {
  const { sidebarState, closeSidebar } = useSidebar();

  return (
    <>
      {/* The account's, the contact's, the deal's and the lead's working sheets, in Encre (PLAN-ENCRE-OUTILS); the others follow. */}
      <AccountSheet accountId={sidebarState.type === 'account' ? sidebarState.entityId : null} onClose={closeSidebar} />
      <OpportunitySheet opportunityId={sidebarState.type === 'opportunity' ? sidebarState.entityId : null} onClose={closeSidebar} />
      <LeadSheet leadId={sidebarState.type === 'lead' ? sidebarState.entityId : null} onClose={closeSidebar} />
      <SubscriberDetailSidebar
        subscriberId={sidebarState.type === 'subscriber' ? sidebarState.entityId : null}
        isOpen={sidebarState.type === 'subscriber'}
        onClose={closeSidebar}
      />
      <ContactSheet
        contactId={sidebarState.type === 'contact' ? sidebarState.entityId : null}
        startEditing={sidebarState.type === 'contact' && sidebarState.edit === true}
        onClose={closeSidebar}
      />
      <MeetingReportSidebar
        reportId={sidebarState.type === 'meetingReport' ? sidebarState.entityId : null}
        isOpen={sidebarState.type === 'meetingReport'}
        onClose={closeSidebar}
      />
      <AppointmentDetailSidebar
        appointmentId={sidebarState.type === 'appointment' ? sidebarState.entityId : null}
        isOpen={sidebarState.type === 'appointment'}
        onClose={closeSidebar}
      />
    </>
  );
}
